import { Component } from '@verndale/core';
import { inView, stagger, timeline } from 'motion';
import { TimelineDefinition } from '@motionone/dom/types/timeline/types';

class NumberedList extends Component {
  constructor(el: HTMLElement) {
    super(el);
    this.animateIn();
  }

  setupDefaults() {
    this.dom = {
      firstNumberedListItem: this.el.querySelector<HTMLElement>(
        '.numbered-list__item:first-of-type'
      ),
      heading: this.el.querySelector<HTMLElement>('.numbered-list__heading'),
      description: this.el.querySelector<HTMLElement>(
        '.numbered-list__description'
      ),
      cta: this.el.querySelector<HTMLElement>('.btn'),
      numberedListItems: this.el.querySelectorAll<HTMLElement>(
        '.numbered-list__item'
      )
    };

    if (this.dom.firstNumberedListItem)
      (this.dom.firstNumberedListItem as HTMLLIElement).classList.add(
        'numbered-list__item--active'
      );
  }

  addListeners() {
    if (this.dom.numberedListItems)
      (this.dom.numberedListItems as NodeList).forEach(item => {
        item.addEventListener('mouseover', this.handleItemEnter.bind(this));
      });
  }

  animateIn() {
    const sequence: TimelineDefinition = [];
    sequence.push([
      this.dom.heading as HTMLHeadingElement,
      { opacity: [0, 1] },
      { duration: 0.8, easing: 'ease-in' }
    ]);

    sequence.push([
      this.dom.description as HTMLElement,
      { opacity: [0, 1] },
      { duration: 0.8, at: 0.2, easing: 'ease-in' }
    ]);
    sequence.push([
      this.dom.cta as HTMLButtonElement,
      { opacity: [0, 1] },
      { duration: 0.8, at: 0.4, easing: 'ease-in' }
    ]);
    if (this.dom.numberedListItems)
      (this.dom.numberedListItems as NodeList).forEach((item, index) => {
        sequence.push([
          item as HTMLElement,
          { opacity: [0, 1], x: [30, 0] },
          {
            duration: 0.8,
            at: 0.6 + 0.2 * (index + 1),
            easing: 'ease-in',
            delay: stagger(0.2)
          }
        ]);
      });

    inView('.numbered-list__heading', () => {
      timeline(sequence);
    });
  }

  handleItemEnter(e: Event) {
    const target = e.target as HTMLElement;
    if (this.dom.firstNumberedListItem)
      if (target !== this.dom.firstNumberedListItem) {
        (this.dom.firstNumberedListItem as HTMLElement).classList.remove(
          'numbered-list__item--active'
        );
      }
  }
}

export default NumberedList;
